import PropTypes from 'prop-types';
import React from "react";
import {
  Col,
  Image,
  Row,
} from "react-bootstrap";
import Tooltip from '../../../../../../components/tooltip';

import cx from "classnames";
import styles from "./Styles.module.scss";
import _ from "lodash";
import Text from 'src/components/text';

class SkillItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: false
    }

    this._handleSelection = this._handleSelection.bind(this);
    this._handleDelete = this._handleDelete.bind(this);

  }

  componentDidMount() {}

  _handleSelection() {
    if (this.props.onSelection) {
      this.props.onSelection(this.props.item);
    }
  }


  _handleDelete() {
    this.props.onDelete(this.props.item);
  }

  render() {
    return (
      <Row
        key={this.props.index}
        className={cx(
          styles.item,
          { [styles.selected]: _.get(this.props, "selected.id") === _.get(this.props, "item.id") },
          { [styles.creating]: this.props.creating }
        )}
        onClick={() => this._handleSelection()}
      >
        <Col md={10} xl={10} lg={10} className={styles.name}>
          <Text text={_.get(this.props,"item.name")} />
        </Col>

        {!this.props.creating && !_.isEmpty(this.props.item.integrationType) && (
          <Col md={1} lg={1} xl={1} className={styles.actions}>
            <Tooltip content={this._getIntegrationType(this.props.item.integrationType) + "Opportunity field"}>
              <Image className={styles.integrationIcon} src={this._getIntegrationIcon(this.props.item.integrationType)} />
            </Tooltip>
          </Col>
        )}

        {!this.props.creating && _.isEmpty(this.props.item.integrationType) && (
          <Col md={1} lg={1} xl={1} className={styles.actions}>
            <Tooltip content="Delete this field">
              <div className={styles.action} onClick={this._handleDelete}>
                <i className="paperflite-delete"></i>
              </div>
            </Tooltip>

          </Col>
        )}
      </Row>
    );
  }
}

SkillItem.contextTypes = {
  selection: PropTypes.object,
};

export default SkillItem;